import { Group, Select, Text, Pagination as MantinePagination } from '@mantine/core';
import classes from './Pagination.module.css';

export interface PaginationProps {
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
  pageSizeOptions?: number[];
  /** Optional label appended after total count (e.g. "participants") */
  entityLabel?: string;
}

export function Pagination({
  page,
  pageSize,
  total,
  totalPages,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions = [10, 25, 50, 100],
  entityLabel,
}: PaginationProps) {
  const startItem = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const endItem = Math.min(page * pageSize, total);

  return (
    <Group justify="space-between" className={classes.container}>
      <Group gap="xs">
        <Text size="sm" c="dimmed">
          Showing {startItem}-{endItem} of {total}{entityLabel ? ` ${entityLabel}` : ''}
        </Text>
      </Group>

      <Group gap="md">
        <Group gap="xs">
          <Text size="sm" c="dimmed">
            Rows per page:
          </Text>
          <Select
            size="xs"
            w={70}
            value={String(pageSize)}
            onChange={(value) => {
              if (value) {
                onPageSizeChange(parseInt(value, 10));
              }
            }}
            data={pageSizeOptions.map((size) => ({ value: String(size), label: String(size) }))}
            comboboxProps={{ withinPortal: true }}
          />
        </Group>

        <MantinePagination
          total={totalPages}
          value={page}
          onChange={onPageChange}
          size="sm"
          withEdges
          className={classes.pagination}
        />
      </Group>
    </Group>
  );
}

export default Pagination;
